import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { EmployeeDto } from '../models/EmployeeDto';
import { EmployeeVm } from '../models/requests/employee-request';
import { EmployeeUploadInfo } from '../models/employee-upload-info';
import { UploadedEmployeeInfo } from '../models/uploaded-employee';
import { ApproveEmployeeUploadVM } from '../models/requests/ApproveEmployeeUploadVM';
import { ExitDateRequestDto } from '../models/ExitDateRequestDto';
import { approveContractVm } from '../models/approveContractVm';
@Injectable({
  providedIn: 'root'
})
export class EmployeesService {


  constructor(private httpClient: HttpClient) { }
  getEmployees(): Observable<ApiResponseObject<EmployeeDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees`);
  }
  

  getEmployeesForRequester(): Observable<ApiResponseObject<EmployeeDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetEmployeesForRequester`);
  }
  getforBioUpdate(): Observable<ApiResponseObject<EmployeeDto[]>> {
     
    var result =  this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetforBioUpdate`);
 
    return result;
  }
  getEmpsforBiometricUpdate(): Observable<ApiResponseObject<EmployeeDto[]>> {
     
    var result =  this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetEmpsforBiometricUpdate`);
 
    return result;
  }
  
  getEmpsforSafetyUpdate(): Observable<ApiResponseObject<EmployeeDto[]>> {
     
    var result =  this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetEmpsforSafetyUpdate`);
 
    return result;
  }
  

  getVerification(): Observable<ApiResponseObject<EmployeeUploadInfo[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeUploadInfo[]>>(`${environment.apiUrl}/EmployeeUploads/GetOutstandingUploads`);
  }

  getUploadedEmployee(id: number): Observable<ApiResponseObject<UploadedEmployeeInfo[]>> {
    return this.httpClient.get<ApiResponseObject<UploadedEmployeeInfo[]>>(`${environment.apiUrl}/EmployeeUploads/GetUploadedEmployeesById/${id}`);
  }

  saveEmployee(employeeVm: EmployeeVm): Observable<ApiResponseObject<EmployeeDto>> {

    return this.httpClient.post<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees`, employeeVm);
  }

  updateBiometrics(data: any): Observable<ApiResponseObject<EmployeeDto>> {

    return this.httpClient.post<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees/UpdateBiometricInfo`, data);
  }

  updateSafety(data: any): Observable<ApiResponseObject<EmployeeDto>> {

    return this.httpClient.post<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees/UpdateSafetyInfo`, data);
  }
  approveEmployeeUpload(data: ApproveEmployeeUploadVM): Observable<ApiResponseObject<number>> {

    var resp = this.httpClient.post<ApiResponseObject<number>>(`${environment.apiUrl}/Employees/ApproveEmployeeUpload`, data);
    return  resp;
  }
  getActiveEmployeesByRequest(id: number, type:string): Observable<ApiResponseObject<EmployeeDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/ActiveEmployeesByRequest/${id}/${type}`);
  }
  getByRequest(id: number, type:string): Observable<ApiResponseObject<EmployeeDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetByRequest/${id}/${type}`);
  }

  
  getPendingExitRequests(): Observable<ApiResponseObject<ExitDateRequestDto[]>> {
    return this.httpClient.get<ApiResponseObject<ExitDateRequestDto[]>>(`${environment.apiUrl}/Employees/GetPendingExitRequests`);
  }
  getByStatus(status: string): Observable<ApiResponseObject<EmployeeDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetByStatus/${status}`);
  }
  TerminateEmployee(data: any): Observable<ApiResponseObject<EmployeeDto>> {

    return this.httpClient.post<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees/TerminateEmployee`, data);
  }
  OffboardEmployee(data: any): Observable<ApiResponseObject<EmployeeDto>> {

    return this.httpClient.post<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees/OffboardEmployee`, data);
  }
  getByFunction(id: number): Observable<ApiResponseObject<EmployeeDto[]>> {
    return this.httpClient.get<ApiResponseObject<EmployeeDto[]>>(`${environment.apiUrl}/Employees/GetByFunction/${id}`);
  }

  ApproveEmpExitDateChange(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Employees/ApproveEmpExitDateChange`, approveContractRequest);
  }
  RejectEmpExitDateChange(approveContractRequest: approveContractVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Employees/RejectEmpExitDateChange`, approveContractRequest);
  }

  ChangeLocation(data: any): Observable<ApiResponseObject<EmployeeDto>> {
   
    return this.httpClient.put<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees/ChangeLocation/${data.locationId}`, data.id);
  }
  ChangeContractor(data: any): Observable<ApiResponseObject<EmployeeDto>> {
   
    return this.httpClient.put<ApiResponseObject<EmployeeDto>>(`${environment.apiUrl}/Employees/updatecontractor`, data);
  }
}
